<template>
  <div>
    <navigationBar :fill="true" />
    <div class="login-warrp full-height">
      <div>
        <router-link class="title" to="/login">建设网站，从<span class="active">域名注册</span>开始</router-link>
        <div style="margin-bottom: 20px;">
          <p class="text">我们诚挚地邀请各位开发者朋友，以及企业的朋友，和我们分享您的云产品使用体验，分享您的每一步跨越</p>
        </div>
        <div style="text-align: center;">
          <Input class="bg-color-303240 height-62 login-input" style="margin-bottom: 20px;" v-model.trim="form.name" clearable placeholder="请输入手机号码/邮箱" />
        </div>
        <div class="width-500" style="display: flex;">
           <Input
            class="bg-color-303240 height-62  login-input"
            type="text"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            style="width: 400px"
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
          >
          </Input>
          <Button
              ref="smsBtn"
              class="sms-btn"
              shape="circle"
              height="60px"
              @click="refreshCode"
              :disabled="codeDisabled"
              style="width: 120px; height: 62px"
          >{{text1}}</Button>
        </div>
        <div style="text-align: center; margin-top: 20px;">
          <Input type="password" class="bg-color-303240 height-62 login-input" v-model.trim="form.password" clearable placeholder="请输入密码" />
        </div>
        <div style="text-align: center; margin-top: 20px;">
          <Input type="password" class="bg-color-303240 height-62 login-input" v-model.trim="form.confirmPassword" clearable placeholder="请再次输入密码" />
        </div>
        <div class="width-500">
          <div class="flex-content-between" style="margin-top: 25px">
            <Checkbox class="color-C4332E remember" v-model="agreement"> 我已阅读并同意遵守</Checkbox>
            <div class="actives" @click="agreementModel" >《智慧康服务协议》</div>
            <div class="actives" @click="privacyModel">《隐私政策》</div>
          </div>
          <Button class="login-btn" style="margin-top: 25px;" long :loading="loading" @click="submit">立即注册</Button>
          <router-link class="sige" to="/login">已有智慧康账户？<span class="actives">立即登录</span></router-link>
        </div>
      </div>
    </div>
    <!-- 智慧康域名注册协议 -->
    <rule-modal
      :show.sync="agreementModelShow"
      :content="agreementRuleContent"
      :title="agreementTitle"
    ></rule-modal>
    <!-- 智慧康隐私声明 -->
    <rule-modal
      :show.sync="privacyModelShow"
      :content="privacyRuleContent"
      :title="privacyRuleTitle"
    ></rule-modal>
    <Modal
        v-model="verifyshow"
        title="验证码"
        @on-ok="getCodeEvent"
        @on-cancel="verifyshow = false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import navigationBar from "components/navigationBar.vue";
import smsBtn from "components/smsBtn.vue";
import { getEncrypt } from "utils/encrypt";
import { getRegisterCode, register } from "api/user.js";
import ruleModal from "components/ruleModal.vue";
import agreement from "assets/rule/agreementRule";
import privacyRule from "assets/rule/privacyRule";
import { API_BASE_URL } from "@/utils/config";

export default {
  name: "sige",
  components: {
    navigationBar,
    smsBtn,
    ruleModal,
  },
  data() {
    return {
      agreement: false,
      form: {
        name: "",
        password: "",
        code: "",
        confirmPassword: "",
      },
      loading: false,
      // 智慧康服务协议
      agreementModelShow: false,
      agreementRuleContent: "",
      agreementTitle: "",
      // 隐私政策
      privacyModelShow: false,
      privacyRuleContent: "",
      privacyRuleTitle: "",
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text1: "获取验证码",
      codeDisabled: false
    };
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号/邮箱不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${API_BASE_URL}/hkweb/dx/register/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    agreementModel() {
      this.agreementModelShow = true;
      if (!this.agreementRuleContent) {
        this.agreementRuleContent = agreement.content;
        this.agreementTitle = agreement.title;
      }
    },
    privacyModel() {
      this.privacyModelShow = true;
      if (!this.privacyRuleContent) {
        this.privacyRuleContent = privacyRule.content;
        this.privacyRuleTitle = privacyRule.title;
      }
    },
    // 获取验证码
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码！");
        this.$refs.smsBtn.reset();
        return;
      }
      getRegisterCode(this.form.name, this.codeValue)
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.text1 = `${i--}秒后再获取`;
            this.codeDisabled = true
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text1 = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text1 = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 提交
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入手机号码/邮箱！");
        return false;
      }
      if (!/^1[0-9]{10}$/.test(this.form.name) && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码/邮箱！");
        return false;
      }
      if (!this.form.code) {
        this.$Message.warning("请输入验证码！");
        return false;
      }
      if (!this.form.password) {
        this.$Message.warning("请输入密码！");
        return false;
      }
      if (!this.form.confirmPassword) {
        this.$Message.warning("请再次输入密码！");
        return false;
      } else if (this.form.password !== this.form.confirmPassword) {
        this.$Message.warning("两次密码不正确！");
        return false;
      }
      if (!this.agreement) {
        this.$Message.warning("请仔细阅读并同意协议！");
        return false;
      }
      const data = {
        source: 1,
        siteUrl: "http://domain.hkzhihuikang.com/",
        pwd: getEncrypt(this.form.password),
        pwd2: getEncrypt(this.form.confirmPassword),
        phone: this.form.name,
        msg: this.form.code,
      };
      this.loading = true;
      register(data)
        .then((res) => {
          this.loading = false;
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("注册成功！");
            this.$router.replace("/login");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.login-warrp{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;

  margin: 0 auto;
  .title{
    display: block;
    text-align: center;
    font-size: 48px;
    color: #333333;
    margin-bottom: 20px;
    .active{
      color: #288DF0;
    }
  }
  .text{
    font-size: 20px;
    line-height: 40px;
    color: #666666;
    text-align: center;
  }
  .actives {
    cursor: pointer;
    color: #288DF0;
    font-weight: 400;
    font-size: 16px;
  }
  .sige{
    display: block;
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
    text-align: left;
  }
  .forgot,.remember{
    font-size: 16px;
    color: #288DF0;
  }
  .width-500{
    width: 500px;
    margin: 0 auto;
    text-align: center;
  }
  /deep/.sms-btn{
    margin-left: 20px;
    .ivu-btn{
      width: 120px;
      background-color: #288DF0;
      color: #fff;
      border-color:#288DF0;
    }

  }
}
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
::v-deep .ivu-modal-content {
  background-color: #fff!important;
}
.sms-btn /deep/ {
  .ivu-btn {
    width: 100%;
    height: 100%;
    background-color: #288DF0;
    color: #fff;
    &:hover{
      border-color: #3E99D4;
    }
  }
}
::v-deep .ivu-btn-primary {
  color: #fff;
  background-color: #288DF0;
  border-color: #288DF0;
}
</style>
